import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadMahndatenStatus: 'idle',
    loadMahndatenError: undefined as any,
    loadMahndatenAtStartStatus: 'idle',
    loadMahndatenAtStartError: undefined as any,
    saveMahndatenStatus: 'idle',
    saveMahndatenError: undefined as any,
    deleteMahndatenStatus: 'idle',
    deleteMahndatenError: undefined as any,

    mahndatenList: [] as any[],
    defaultValues: undefined as any,
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadMahndaten = createAsyncThunk('mahndatenSlice/loadMahndaten', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/mahndaten/?action=eql&SPEICHERTYP=0&SPEICHERID=0`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMahndatenStatus } = getState().mahndatenSlice
        return loadMahndatenStatus !== 'pending'
    }
})

export const loadMahndatenAtStart = createAsyncThunk('mahndatenSlice/loadMahndatenAtStart', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/mahndaten/?action=eql&SPEICHERTYP=0&SPEICHERID=0`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMahndatenAtStartStatus } = getState().mahndatenSlice
        return loadMahndatenAtStartStatus !== 'pending'
    }
})

export const saveMahndaten = createAsyncThunk('mahndatenSlice/saveMahndaten', async ({ mahndaten }: any, { rejectWithValue }: any) => {
    let promises = []
    if (mahndaten?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/mahndaten/${ mahndaten?.HDR_ID }/`,
            prepareData(mahndaten),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/mahndaten/`,
            prepareData(mahndaten),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveMahndatenStatus } = getState().mahndatenSlice
        return saveMahndatenStatus !== 'pending'
    }
})

export const deleteMahndaten = createAsyncThunk('mahndatenSlice/deleteMahndaten', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/mahndaten/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteMahndatenStatus } = getState().mahndatenSlice
        return deleteMahndatenStatus !== 'pending'
    }
})

const MahndatenSlice = createSlice({
    name: 'mahndatenSlice',
    initialState,
    reducers: {
        resetloadMahndaten: (state) => {
            state.formItem = undefined
            state.loadMahndatenError = undefined
        },
        resetloadMahndatenError: (state) => {
            state.loadMahndatenError = undefined
        },
        resetloadMahndatenAtStart: (state) => {
            state.defaultValues = undefined
            state.loadMahndatenAtStartError = undefined
        },
        resetloadMahndatenAtStartError: (state) => {
            state.loadMahndatenAtStartError = undefined
        },
        resetsaveMahndaten: (state) => {
            state.formItem = undefined
            state.saveMahndatenError = undefined
        },
        resetsaveMahndatenError: (state) => {
            state.saveMahndatenError = undefined
        },
        resetdeleteMahndatenError: (state) => {
            state.deleteMahndatenError = undefined
        },
        removeFromMahndatenListById: (state, action) => {
            state.mahndatenList = state.mahndatenList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromMahndatenListByIds: (state, action) => {
            state.mahndatenList = state.mahndatenList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.mahndatenList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadMahndatenStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.mahndatenList = []
            state.loadMahndatenStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(loadMahndaten.pending, (state) => {
            state.loadMahndatenStatus = 'pending'
            state.loadMahndatenError = undefined
        })
        builder.addCase(loadMahndaten.fulfilled, (state, action) => {
            state.loadMahndatenStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.mahndatenList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.mahndatenList.push(newItem) }
                else { state.mahndatenList[i] = { ...state.mahndatenList[i], ...newItem } }
            }
        })
        builder.addCase(loadMahndaten.rejected, (state, action) => {
            state.loadMahndatenStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMahndatenError = action.error.message
            } else {
                state.loadMahndatenError = action.payload
            }
        })

        builder.addCase(loadMahndatenAtStart.pending, (state) => {
            state.loadMahndatenAtStartStatus = 'pending'
            state.loadMahndatenAtStartError = undefined
        })
        builder.addCase(loadMahndatenAtStart.fulfilled, (state, action) => {
            state.loadMahndatenAtStartStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadMahndatenAtStart.rejected, (state, action) => {
            state.loadMahndatenAtStartStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMahndatenAtStartError = action.error.message
            } else {
                state.loadMahndatenAtStartError = action.payload
            }
        })

        builder.addCase(saveMahndaten.pending, (state) => {
            state.saveMahndatenStatus = 'pending'
            state.saveMahndatenError = undefined
        })
        builder.addCase(saveMahndaten.fulfilled, (state, action) => {
            state.saveMahndatenStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.mahndatenList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.mahndatenList.push(newItem) }
                else { state.mahndatenList[i] = { ...state.mahndatenList[i], ...newItem } }
            }
        })
        builder.addCase(saveMahndaten.rejected, (state, action) => {
            state.saveMahndatenStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveMahndatenError = action.error.message
            } else {
                state.saveMahndatenError = action.payload
            }
        })

        builder.addCase(deleteMahndaten.pending, (state) => {
            state.deleteMahndatenStatus = 'pending'
            state.deleteMahndatenError = undefined
        })
        builder.addCase(deleteMahndaten.fulfilled, (state, action) => {
            state.deleteMahndatenStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.mahndatenList = state.mahndatenList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.mahndatenList = state.mahndatenList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteMahndaten.rejected, (state, action) => {
            state.deleteMahndatenStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteMahndatenError = action.error.message
            } else {
                state.deleteMahndatenError = action.payload
            }
        })

    }
})

export const {
    resetloadMahndaten,
    resetloadMahndatenError,
    resetloadMahndatenAtStart,
    resetloadMahndatenAtStartError,
    resetsaveMahndaten,
    resetsaveMahndatenError,
    resetdeleteMahndatenError,
    removeFromMahndatenListById,
    removeFromMahndatenListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = MahndatenSlice.actions
export default MahndatenSlice.reducer
